import { ContentBlockGrid } from "@gift/ui";

export const ContentBlock_2: React.FC = () => (
    <ContentBlockGrid
        headline="Rozdělte přání na malé dílky a začnou se dít věci"
        description="Toužíte po exotických líbánkách? Rozkouskujte je na letenku, potápění s delfíny nebo romantickou večeři při západu slunce. Hosté se sami rozhodnou, na kterou část vašeho snu přispějí."
        backgroundColors={["#EFF5F7", "#E4E0EB", "#f6f3ea"]}
    />
);
